export class Identity {
    constructor(
        public name: string = null,
        public token: string = null,
        public refreshToken: string = null,
        public tenantId: number = null
    ) { }
}